module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-27-89b65ea6bd8a4c2067ab0b63938dfba4.jpg";